import {
    ClickElement,
    ClickText,
    ClickType,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackThumbnailClicked(url: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'Select',
        label: 'PicturePreview',
        eventData: {
            eventName: GA4EventName.SwitchPicture,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_type: ClickType.Select,
            click_url: url,
        },
    });
}

async function trackImageSlide(label: string, url: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'Slide',
        label,
        eventData: {
            eventName: GA4EventName.SwitchPicture,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_type: label,
            click_url: url,
        },
    });
}

async function trackOnClickImageSliderOfNewGallery(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ShowPopup,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_element: ClickElement.OpenImageModal,
        },
    });
}

async function trackCloseGalleryModal(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClosePopup,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_element: ClickElement.CloseImageModal,
        },
    });
}

async function trackOnViewAllImagesIndexButton(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickButton,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_element: ClickElement.OpenImageGallery,
            click_text: ClickText.ShowAllImages,
        },
    });
}

async function trackOpenAnImageFromGallery(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.SwitchPicture,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_element: ClickElement.SelectAnImageInModal,
            click_type: ClickType.Select,
        },
    });
}

async function trackOnSwipeImageGalleryModal(direction: 'next' | 'previous'): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.SwitchPicture,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_element:
                direction === 'next' ? ClickElement.SlideNext : ClickElement.SlidePrevious,
            click_type: direction === 'next' ? ClickType.SlideNext : ClickType.SlidePrevious,
        },
    });
}

export {
    trackCloseGalleryModal,
    trackImageSlide,
    trackOnClickImageSliderOfNewGallery,
    trackOnSwipeImageGalleryModal,
    trackOnViewAllImagesIndexButton,
    trackOpenAnImageFromGallery,
    trackThumbnailClicked,
};
